import { render, staticRenderFns } from "./RoleDetails.vue?vue&type=template&id=69c5663c&"
import script from "./RoleDetails.vue?vue&type=script&lang=ts&"
export * from "./RoleDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports